/* global google */

itsoftApp.createModule("map", ["pageLoad", "windowResize"], function() {
    var parents = $(".js-map");
    if (!parents.length) {
        return false;
    }


    // Local variables
    var mapElementClass = "js-map-canvas";
    var image = "/media/images/map-marker.png";
    var dAttrLat = "data-lat";
    var dAttrLng = "data-lng";
    var markElemsClass = "js-map-address";
    var initFuncArr = [];



    // На случай,
    // если карт несколько
    parents.each(function(index) {
        var parent = $(this);
        var mapElement = parent.find("." + mapElementClass);
        var marker = [];
        var infowindow = [];
        var map;
        var markElems = $("." + markElemsClass);
        var mapIndex = index;


        // Функции легче всего определить
        // для каждого блока parent
        // (хотя правильнее их было бы вынести, добавив
        // определённую карту как доп. параметр).

        var addMarker = function(location, name, contentstr) {
            marker[name] = new google.maps.Marker({
                position: location,
                map: map,
                icon: image
            });
            marker[name].setMap(map);
            infowindow[name] = new google.maps.InfoWindow({
                content: contentstr
            });
            google.maps.event.addListener(marker[name], "click", function() {
                infowindow[name].open(map, marker[name]);
            });

            DEBUG && console.log("[module map] for map #" + mapIndex + " added marker with name '" + name);
        };

        var initMap = function() {
            var lat, lng;

            // Приоритет для центрирования карты - атрибуты элемента mapElement,
            // затем центрирование будет идти для первого маркера из списка markElems.
            if (mapElement.attr(dAttrLat) && mapElement.attr(dAttrLng)) {
                lat = mapElement.attr(dAttrLat);
                lng = mapElement.attr(dAttrLng);
            } else if (markElems.length > 0) {
                lat = markElems.eq(0).attr(dAttrLat);
                lng = markElems.eq(0).attr(dAttrLng);
            } else {
                DEBUG && console.log("%c[module map] can't obtain lat/lng for map #" + mapIndex + ". check your markup!", "color: red");
                return;
            }

            var myLatlng = new google.maps.LatLng(lat, lng);
            var setZoom = parseInt(mapElement.attr("data-zoom"));
            var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];

            var styledMap = new google.maps.StyledMapType(styles, {
                name: "Styled Map"
            });

            var mapOptions = {
                scrollwheel: false,
                zoom: setZoom,
                panControl: false,
                panControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                zoomControl: false,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.LARGE,
                    position: google.maps.ControlPosition.RIGHT_BOTTOM
                },
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                center: myLatlng,
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                disableDefaultUI: true,
                mapTypeControl: false,
                overviewMapControl: false,
                streetViewControl: false,
                noClear: false,
                language: "ru"
            };

            map = new google.maps.Map(mapElement.get(0), mapOptions);
            map.mapTypes.set("map_style", styledMap);
            map.setMapTypeId("map_style");

            markElems.each(function(index) {
                var self = $(this);
                var markLat = self.attr(dAttrLat);
                var markLng = self.attr(dAttrLng);
                var markName = "template_marker_" + index;
                var markLocat = new google.maps.LatLng(markLat, markLng);
                var markStr = self.attr("data-string");

                addMarker(markLocat, markName, markStr);
            });

            DEBUG && console.log("[module map] initialized map #" + mapIndex);
        };

        // Добавляем одну функцию инициализации в общий массив,
        // по которому потом (после загрузки библиотеки гугла)
        // пройдётся функция initializeAll.
        initFuncArr.push(initMap);

    });


    // Когда библиотека загружена,
    // просто проходимся по массиву и инициализируем
    // все функции в нём.
    var initializeAll = function() {
        for (var i = 0; i < initFuncArr.length; i++) {
            if (typeof initFuncArr[i] === "function") {
                initFuncArr[i]();
            }
        }
        parents.removeClass("is-preparing ");
    };


    var loadAndInit = function() {
        DEBUG && console.log("[module map] starting to load map library");
        itsoftApp.loadScript("//maps.googleapis.com/maps/api/js?sensor=false&language=ru&key=AIzaSyCL9u5v3SGN6CfgvxkFxZNVkDVLXywfCLw", initializeAll);
    };

    // Вешаем начало загрузки библиотеки
    // на событие load.
    // Это хорошо, так как обычно карта не настолько сильно нужна,
    // чтобы грузить её прям так сразу.
    itsoftApp.modules.pageLoad.addEvent(loadAndInit);
});
